import { useParams, Link } from 'react-router-dom'
import { getGuideBySlug } from '../data/scenarioGuides'

export function ScenarioGuide() {
  const { slug } = useParams<{ slug: string }>()
  const guide = slug ? getGuideBySlug(slug) : null

  if (!guide) {
    return (
      <div className="page">
        <p>未找到该场景指南。</p>
        <Link to="/deploy" className="btn btn-primary">返回部署专区</Link>
      </div>
    )
  }

  return (
    <div className="page">
      <Link to="/deploy" className="back-link">← 部署专区</Link>
      <h1 className="section-title">{guide.title}</h1>
      <p className="lead" style={{ marginBottom: '2rem' }}>{guide.subtitle}</p>

      <div className="card">
        <h2>核心 Skills</h2>
        <ul className="skill-list">
          {guide.skills.map((s) => (
            <li key={s.name}><strong>{s.name}</strong> — {s.desc}</li>
          ))}
        </ul>
      </div>

      {guide.security && (
        <div className="card security-note">
          <h2>安全建议</h2>
          <p>{guide.security}</p>
        </div>
      )}

      <div className="card">
        <h2>配置要点</h2>
        <ol className="content-list">
          {guide.content.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ol>
      </div>

      {guide.code && (
        <div className="card">
          <h2>示例</h2>
          <pre className="code-block">{guide.code}</pre>
        </div>
      )}
    </div>
  )
}
